(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nopics-text-with-icon"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(n, min, max) { return Math.min(Math.max(n, min), max); }
    function initTitleAnimation(section) {
      if (section.getAttribute('data-title-animate') !== 'true') return;
      var title = section.querySelector('[data-pd-title]');
      if (!title) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) { title.classList.add('is-visible'); return; }
      function reveal() { title.classList.add('is-visible'); }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) { entries.forEach(function (entry) { if (entry.isIntersecting) { reveal(); observer.disconnect(); } }); }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });
        observer.observe(section);
      } else { reveal(); }
    }
    function initMobileCarousel(section) {
      var viewport = section.querySelector('[data-pd-viewport]');
      var track = section.querySelector('[data-pd-track]');
      var progress = section.querySelector('[data-pd-progress]');
      var thumb = section.querySelector('[data-pd-thumb]');
      var prevBtn = section.querySelector('[data-pd-prev]');
      var nextBtn = section.querySelector('[data-pd-next]');
      if (!viewport) return;
      var mobileMq = window.matchMedia('(max-width: 749px)');
      var scrollEdgeThreshold = 4;
      function isMobile() { return mobileMq.matches; }
      function maxScroll() { return Math.max(0, viewport.scrollWidth - viewport.clientWidth); }
      function scrollRatio() { var max = maxScroll(); return max <= 0 ? 0 : viewport.scrollLeft / max; }
      function thumbTravel() { if (!progress || !thumb) return 0; return Math.max(0, progress.clientWidth - thumb.offsetWidth); }
      function setThumbPosition(ratio) { if (!thumb || !isMobile()) return; thumb.style.transform = 'translateX(' + ratio * thumbTravel() + 'px)'; if (progress) progress.setAttribute('aria-valuenow', String(Math.round(ratio * 100))); }
      function cardStep() { if (!track) return viewport.clientWidth; var card = track.querySelector('.oas-proddetail__card'); if (!card) return viewport.clientWidth; var gap = parseFloat(window.getComputedStyle(track).gap) || 0; return card.offsetWidth + gap; }
      function updateNavButtons() { if (!prevBtn && !nextBtn) return; if (!isMobile()) { if (prevBtn) prevBtn.disabled = false; if (nextBtn) nextBtn.disabled = false; return; } var max = maxScroll(); var left = viewport.scrollLeft; if (prevBtn) prevBtn.disabled = left <= scrollEdgeThreshold; if (nextBtn) nextBtn.disabled = max <= scrollEdgeThreshold || left >= max - scrollEdgeThreshold; }
      function scrollByDirection(dir) { if (!isMobile()) return; var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'; viewport.scrollBy({ left: dir * cardStep(), behavior: behavior }); }
      function onScroll() { if (!isMobile()) return; setThumbPosition(scrollRatio()); updateNavButtons(); }
      var scrollRaf = 0;
      function onScrollRaf() { if (scrollRaf) return; scrollRaf = requestAnimationFrame(function () { scrollRaf = 0; onScroll(); }); }
      viewport.addEventListener('scroll', onScrollRaf, { passive: true });
      if (progress) progress.addEventListener('click', function (e) { if (!isMobile()) return; var travel = thumbTravel(); if (travel <= 0) return; var rect = progress.getBoundingClientRect(); var thumbHalf = thumb ? thumb.offsetWidth / 2 : 0; var ratio = clamp((e.clientX - rect.left - thumbHalf) / travel, 0, 1); viewport.scrollLeft = ratio * maxScroll(); setThumbPosition(ratio); });
      if (prevBtn) prevBtn.addEventListener('click', function () { scrollByDirection(-1); });
      if (nextBtn) nextBtn.addEventListener('click', function () { scrollByDirection(1); });
      mobileMq.addEventListener('change', function () { if (isMobile()) { setThumbPosition(scrollRatio()); updateNavButtons(); } else if (thumb) { thumb.style.transform = ''; updateNavButtons(); } });
      window.addEventListener('resize', function () { if (isMobile()) { setThumbPosition(scrollRatio()); updateNavButtons(); } }, { passive: true });
      if (isMobile()) { setThumbPosition(0); updateNavButtons(); }
      var drag = null;
      function endDrag(e) { if (!drag) return; viewport.classList.remove('is-dragging'); try { if (e && e.pointerId != null) viewport.releasePointerCapture(e.pointerId); } catch (err) {} if (drag.moved) { viewport.querySelectorAll('.oas-proddetail__card-link').forEach(function (link) { link.addEventListener('click', function (ev) { ev.preventDefault(); }, { once: true, capture: true }); }); } drag = null; }
      viewport.addEventListener('pointerdown', function (e) { if (!isMobile()) return; if (e.button !== 0 && e.pointerType === 'mouse') return; drag = { id: e.pointerId, x: e.clientX, scrollLeft: viewport.scrollLeft, moved: false }; viewport.classList.add('is-dragging'); viewport.setPointerCapture(e.pointerId); });
      viewport.addEventListener('pointermove', function (e) { if (!drag || drag.id !== e.pointerId) return; var dx = e.clientX - drag.x; if (Math.abs(dx) > 4) drag.moved = true; viewport.scrollLeft = drag.scrollLeft - dx; }, { passive: true });
      viewport.addEventListener('pointerup', endDrag); viewport.addEventListener('pointercancel', endDrag);
    }
    function initSection(section) { initTitleAnimation(section); initMobileCarousel(section); }
    document.querySelectorAll('[data-pd-section]').forEach(initSection);
    document.addEventListener('shopify:section:load', function (e) { var section = e.target.querySelector('[data-pd-section]'); if (section) initSection(section); });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-bottom-anchor-nav"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var SCROLL_LOCK_MS = 800;
    var globalScrollBound = false;
    var scrollTicking = false;
    var activeBars = [];

    function readRootVarPx(name) {
      var raw = getComputedStyle(document.documentElement).getPropertyValue(name);
      var value = parseFloat(raw);
      return Number.isFinite(value) ? value : 0;
    }

    function getHeaderStackOffset() {
      return readRootVarPx('--oas-header-sticky-top') + readRootVarPx('--header-height');
    }

    function initPin(root, bar) {
      if (root._oasPinInited) return;
      root._oasPinInited = true;

      var sentinel = root.querySelector('.oas-stickynav__sentinel');
      if (!sentinel) return;

      var basePinTop = parseInt(bar.getAttribute('data-pin-top'), 10) || 0;
      var isPinned = false;
      var pinTicking = false;

      function setPinned(pinned) {
        if (isPinned === pinned) return;
        isPinned = pinned;
        root.classList.toggle('is-pinned', pinned);
      }

      function updatePin() {
        var pinTop = basePinTop + getHeaderStackOffset();
        var pinRelease = pinTop + 3;
        root.style.setProperty('--sn-effective-top', pinTop + 'px');
        var top = sentinel.getBoundingClientRect().top;
        if (!isPinned && top <= pinTop) {
          setPinned(true);
        } else if (isPinned && top > pinRelease) {
          setPinned(false);
        }
      }

      function onPinScroll() {
        if (pinTicking) return;
        pinTicking = true;
        requestAnimationFrame(function () {
          updatePin();
          pinTicking = false;
        });
      }

      window.addEventListener('scroll', onPinScroll, { passive: true });
      window.addEventListener('resize', onPinScroll, { passive: true });
      updatePin();

      root._pinCleanup = function () {
        window.removeEventListener('scroll', onPinScroll);
        window.removeEventListener('resize', onPinScroll);
        root.classList.remove('is-pinned');
        isPinned = false;
      };
    }

    function initAnchors(bar) {
      if (bar._oasAnchorInited) return;
      bar._oasAnchorInited = true;

      var tabs = bar.querySelectorAll('.oas-stickynav__tab[data-target]');
      if (!tabs.length) return;

      var baseScrollOffset = parseInt(bar.getAttribute('data-scroll-offset'), 10) || 0;
      var basePinTop = parseInt(bar.getAttribute('data-pin-top'), 10) || 0;
      var currentActive = null;
      var isScrolling = false;
      var scrollTimer = null;

      var targets = [];
      tabs.forEach(function (tab) {
        var id = tab.getAttribute('data-target');
        if (id) targets.push({ id: id, tab: tab });
      });

      function setActive(id) {
        if (id === currentActive) return;
        currentActive = id;
        targets.forEach(function (t) {
          var active = t.id === id;
          t.tab.classList.toggle('is-active', active);
          t.tab.setAttribute('aria-selected', active ? 'true' : 'false');
        });
      }

      function normalizeSlug(value) {
        return String(value || '')
          .trim()
          .toLowerCase()
          .replace(/^shopify-section-/, '')
          .replace(/^oasmobility-/, '')
          .replace(/^oas-/, '')
          .replace(/[\s_]+/g, '-')
          .replace(/[^a-z0-9-]/g, '')
          .replace(/-+/g, '-');
      }

      function resolveTarget(id) {
        if (!id) return null;
        var raw = String(id).trim();
        var el;

        el = document.getElementById(raw);
        if (el) return el;

        try {
          el = document.querySelector('[data-anchor="' + raw.replace(/\\/g, '\\\\').replace(/"/g, '\\"') + '"]');
        } catch (e) {
          el = null;
        }
        if (el) return el;

        if (raw.indexOf('shopify-section-') === 0) {
          el = document.getElementById(raw);
          if (el) return el;
        }

        el = document.getElementById('shopify-section-' + raw);
        if (el) return el;

        var shopifySections = document.querySelectorAll('[id^="shopify-section-"]');
        var rawLower = raw.toLowerCase();
        var rawSlug = normalizeSlug(raw);
        var rawUnderscore = rawSlug.replace(/-/g, '_');

        for (var i = 0; i < shopifySections.length; i++) {
          var sectionEl = shopifySections[i];
          var sectionId = sectionEl.id;
          var instanceKey = sectionId.split('__').pop().toLowerCase();

          if (sectionId === 'shopify-section-' + raw) return sectionEl;
          if (instanceKey === rawLower || instanceKey === rawUnderscore) return sectionEl;
          if (sectionId.toLowerCase().indexOf('__' + rawLower) !== -1) return sectionEl;
          if (sectionId.toLowerCase().indexOf('__' + rawUnderscore) !== -1) return sectionEl;
        }

        var slug = rawSlug;
        var classNames = [
          'shopify-section--oas-' + slug,
          'shopify-section--' + slug,
          'shopify-section--oasmobility-' + slug
        ];

        for (var c = 0; c < classNames.length; c++) {
          el = document.querySelector('.' + classNames[c]);
          if (el) return el;
        }

        return null;
      }

      function getScrollOffset() {
        return baseScrollOffset + basePinTop + getHeaderStackOffset() + (bar.offsetHeight || 0);
      }

      function syncActive() {
        if (isScrolling) return;
        var scrollOffset = getScrollOffset();
        var scrollY = window.scrollY || window.pageYOffset;
        var winH = window.innerHeight;
        var docH = document.documentElement.scrollHeight;
        var checkLine = scrollY + scrollOffset + 120;
        var bestId = null;

        targets.forEach(function (t) {
          var el = resolveTarget(t.id);
          if (!el) return;
          var top = el.getBoundingClientRect().top + scrollY;
          if (top <= checkLine) {
            bestId = t.id;
          }
        });

        if (scrollY + winH >= docH - 10 && targets.length > 0) {
          bestId = targets[targets.length - 1].id;
        }

        if (bestId) setActive(bestId);
      }

      function scrollToTarget(id) {
        var el = resolveTarget(id);
        if (!el) return;
        var scrollOffset = getScrollOffset();

        isScrolling = true;
        setActive(id);

        var top = el.getBoundingClientRect().top + (window.scrollY || window.pageYOffset) - scrollOffset;
        window.scrollTo({ top: Math.max(0, top), behavior: 'smooth' });

        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(function () {
          isScrolling = false;
          syncActive();
        }, SCROLL_LOCK_MS);
      }

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function (e) {
          e.preventDefault();
          var id = tab.getAttribute('data-target');
          if (id) scrollToTarget(id);
        });
      });

      bar._oasSync = syncActive;
      activeBars.push(bar);
      syncActive();

      bar._anchorCleanup = function () {
        bar._oasAnchorInited = false;
        bar._oasSync = null;
        activeBars = activeBars.filter(function (b) { return b !== bar; });
        clearTimeout(scrollTimer);
      };
    }

    function initRoot(root) {
      if (root._oasInited) return;
      root._oasInited = true;

      var bar = root.querySelector('.oas-stickynav[id^="oas-stickynav-"]');
      if (!bar) return;

      initPin(root, bar);
      initAnchors(bar);

      root._cleanup = function () {
        root._oasInited = false;
        if (root._pinCleanup) root._pinCleanup();
        root._pinCleanup = null;
        root._oasPinInited = false;
        if (bar._anchorCleanup) bar._anchorCleanup();
      };
    }

    function onGlobalScroll() {
      if (scrollTicking) return;
      scrollTicking = true;
      requestAnimationFrame(function () {
        activeBars.forEach(function (bar) {
          if (bar._oasSync) bar._oasSync();
        });
        scrollTicking = false;
      });
    }

    function boot() {
      try {
        document.querySelectorAll('.oas-stickynav-root').forEach(initRoot);
        if (!globalScrollBound) {
          globalScrollBound = true;
          window.addEventListener('scroll', onGlobalScroll, { passive: true });
          window.addEventListener('resize', onGlobalScroll, { passive: true });
        }
      } catch (err) {
        console.warn('OAS anchor nav init failed', err);
      }
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var root = e.target.querySelector('.oas-stickynav-root');
      if (root) boot();
    });

    document.addEventListener('shopify:section:unload', function (e) {
      var root = e.target.querySelector('.oas-stickynav-root');
      if (root && root._cleanup) root._cleanup();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-detail-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(n, min, max) {
      return Math.min(Math.max(n, min), max);
    }

    function initTitleAnimation(section) {
      if (section.getAttribute('data-title-animate') !== 'true') return;
      var title = section.querySelector('[data-detail-title]');
      if (!title) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        title.classList.add('is-visible');
        return;
      }
      function reveal() {
        title.classList.add('is-visible');
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                reveal();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(section);
      } else {
        reveal();
      }
    }

    function initMobileSync(section, viewport) {
      var mobileNav = section.querySelector('[data-detail-mobile-nav]');
      var indicator = section.querySelector('[data-detail-indicator]');
      var navItems = section.querySelectorAll('[data-detail-nav-item]');
      var cards = section.querySelectorAll('[data-detail-card]');
      if (!mobileNav || !viewport || !navItems.length || !cards.length) return null;

      var mobileMq = window.matchMedia('(max-width: 749px)');
      var activeIndex = 0;
      var scrollRaf = null;
      var syncingScroll = false;

      function isMobile() {
        return mobileMq.matches;
      }

      function updateSlideWidths() {
        if (!isMobile()) {
          section.style.removeProperty('--detail-slide-width');
          return;
        }
        var slideWidth = viewport.clientWidth;
        if (slideWidth > 0) {
          section.style.setProperty('--detail-slide-width', slideWidth + 'px');
        }
      }

      function scrollLeftForIndex(index) {
        var card = cards[index];
        if (!card) return 0;
        return card.offsetLeft;
      }

      function updateIndicator() {
        if (!indicator || !isMobile()) return;
        var activeItem = navItems[activeIndex];
        var rail = mobileNav.querySelector('.oas-detail__mobile-rail');
        if (!activeItem || !rail) return;
        var railTop = rail.getBoundingClientRect().top;
        var itemRect = activeItem.getBoundingClientRect();
        indicator.style.top = itemRect.top - railTop + 'px';
        indicator.style.height = itemRect.height + 'px';
      }

      function setActiveIndex(index, options) {
        options = options || {};
        var next = clamp(index, 0, cards.length - 1);
        if (next === activeIndex && !options.force) return;
        activeIndex = next;

        navItems.forEach(function (item, i) {
          var isActive = i === activeIndex;
          item.classList.toggle('is-active', isActive);
          item.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        updateIndicator();

        if (options.scroll !== false && isMobile()) {
          syncingScroll = true;
          viewport.scrollTo({
            left: scrollLeftForIndex(activeIndex),
            behavior: options.instant ? 'auto' : 'smooth',
          });
          window.setTimeout(function () {
            syncingScroll = false;
          }, options.instant ? 0 : 420);
        }
      }

      function indexFromScroll() {
        if (!cards.length) return 0;
        var slideWidth = viewport.clientWidth;
        if (slideWidth <= 0) return 0;
        return clamp(Math.round(viewport.scrollLeft / slideWidth), 0, cards.length - 1);
      }

      function onViewportScroll() {
        if (!isMobile() || syncingScroll) return;
        if (scrollRaf) cancelAnimationFrame(scrollRaf);
        scrollRaf = requestAnimationFrame(function () {
          setActiveIndex(indexFromScroll(), { scroll: false });
        });
      }

      navItems.forEach(function (item) {
        item.addEventListener('click', function () {
          var index = parseInt(item.getAttribute('data-index'), 10);
          if (Number.isNaN(index)) return;
          setActiveIndex(index);
        });
      });

      viewport.addEventListener('scroll', onViewportScroll, { passive: true });
      if ('onscrollend' in window) {
        viewport.addEventListener('scrollend', onViewportScroll, { passive: true });
      }

      mobileMq.addEventListener('change', function () {
        updateSlideWidths();
        if (isMobile()) {
          setActiveIndex(activeIndex, { force: true, instant: true });
        }
        updateIndicator();
      });

      window.addEventListener(
        'resize',
        function () {
          updateSlideWidths();
          if (isMobile()) {
            updateIndicator();
          }
        },
        { passive: true }
      );

      updateSlideWidths();
      setActiveIndex(0, { force: true, instant: true });

      return {
        isMobile: isMobile,
        setActiveIndex: setActiveIndex,
        updateSlideWidths: updateSlideWidths,
      };
    }

    function initCarousel(section) {
      var viewport = section.querySelector('[data-detail-viewport]');
      var progress = section.querySelector('[data-detail-progress]');
      var thumb = section.querySelector('[data-detail-thumb]');
      if (!viewport) return;

      var mobileSync = initMobileSync(section, viewport);

      var draggingViewport = false;
      var draggingThumb = false;
      var startX = 0;
      var startScroll = 0;
      var startThumbX = 0;
      var autoplayTimer = null;
      var autoplay = section.getAttribute('data-autoplay') === 'true';
      var autoplayInterval = parseInt(section.getAttribute('data-autoplay-interval'), 10) || 5000;

      function maxScroll() {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function scrollRatio() {
        var max = maxScroll();
        return max <= 0 ? 0 : viewport.scrollLeft / max;
      }

      function thumbTravel() {
        if (!progress || !thumb) return 0;
        return Math.max(0, progress.clientWidth - thumb.offsetWidth);
      }

      function setThumbPosition(ratio) {
        if (!thumb) return;
        thumb.style.transform = 'translateX(' + ratio * thumbTravel() + 'px)';
        if (progress) {
          progress.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
        }
      }

      function scrollToRatio(ratio) {
        viewport.scrollLeft = ratio * maxScroll();
        setThumbPosition(ratio);
      }

      function onScroll() {
        if (mobileSync && mobileSync.isMobile()) return;
        setThumbPosition(scrollRatio());
      }

      viewport.addEventListener('scroll', onScroll, { passive: true });

      viewport.addEventListener('pointerdown', function (e) {
        if (e.button !== 0) return;
        if (e.target.closest('a')) return;
        if (mobileSync && mobileSync.isMobile()) return;
        draggingViewport = true;
        startX = e.clientX;
        startScroll = viewport.scrollLeft;
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(e.pointerId);
      });

      viewport.addEventListener('pointermove', function (e) {
        if (!draggingViewport) return;
        viewport.scrollLeft = startScroll - (e.clientX - startX);
      });

      function endViewportDrag(e) {
        if (!draggingViewport) return;
        draggingViewport = false;
        viewport.classList.remove('is-dragging');
        try {
          viewport.releasePointerCapture(e.pointerId);
        } catch (err) { /* noop */ }
        resetAutoplay();
      }

      viewport.addEventListener('pointerup', endViewportDrag);
      viewport.addEventListener('pointercancel', endViewportDrag);

      if (progress && thumb) {
        progress.addEventListener('pointerdown', function (e) {
          if (e.target === thumb) return;
          var rect = progress.getBoundingClientRect();
          var ratio = clamp((e.clientX - rect.left - thumb.offsetWidth / 2) / thumbTravel(), 0, 1);
          scrollToRatio(ratio);
          resetAutoplay();
        });

        thumb.addEventListener('pointerdown', function (e) {
          e.stopPropagation();
          draggingThumb = true;
          startX = e.clientX;
          startThumbX = scrollRatio() * thumbTravel();
          thumb.classList.add('is-dragging');
          thumb.setPointerCapture(e.pointerId);
        });

        thumb.addEventListener('pointermove', function (e) {
          if (!draggingThumb) return;
          var travel = thumbTravel();
          if (travel <= 0) return;
          var nextX = startThumbX + (e.clientX - startX);
          scrollToRatio(clamp(nextX / travel, 0, 1));
        });

        function endThumbDrag(e) {
          if (!draggingThumb) return;
          draggingThumb = false;
          thumb.classList.remove('is-dragging');
          try {
            thumb.releasePointerCapture(e.pointerId);
          } catch (err) { /* noop */ }
          resetAutoplay();
        }

        thumb.addEventListener('pointerup', endThumbDrag);
        thumb.addEventListener('pointercancel', endThumbDrag);
      }

      function stopAutoplay() {
        clearInterval(autoplayTimer);
        autoplayTimer = null;
      }

      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      function startAutoplay() {
        if (mobileSync && mobileSync.isMobile()) return;
        if (!autoplay || maxScroll() <= 0) return;
        autoplayTimer = setInterval(function () {
          var max = maxScroll();
          if (max <= 0) return;
          var next = viewport.scrollLeft + viewport.clientWidth * 0.5;
          if (next >= max - 2) {
            viewport.scrollTo({ left: 0, behavior: 'smooth' });
          } else {
            viewport.scrollTo({ left: next, behavior: 'smooth' });
          }
        }, autoplayInterval);
      }

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      window.addEventListener(
        'resize',
        function () {
          if (mobileSync && mobileSync.updateSlideWidths) {
            mobileSync.updateSlideWidths();
          }
          onScroll();
        },
        { passive: true }
      );

      onScroll();
      startAutoplay();
    }

    function initSection(section) {
      if (!section || !section.matches('.oas-detail')) return;
      initTitleAnimation(section);
      initCarousel(section);
    }

    function boot() {
      document.querySelectorAll('.oas-detail[data-detail-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.oas-detail[data-detail-section]');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-dual-carousel"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function initHeadingAnimation(section) {
      if (section.getAttribute('data-title-animate') !== 'true') return;
      var headings = section.querySelectorAll('[data-dual-heading]');
      if (!headings.length) return;

      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        headings.forEach(function (heading) { heading.classList.add('is-visible'); });
        return;
      }

      var once = section.getAttribute('data-title-once') !== 'false';

      if (!('IntersectionObserver' in window)) {
        headings.forEach(function (heading) { heading.classList.add('is-visible'); });
        return;
      }

      headings.forEach(function (heading) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                heading.classList.add('is-visible');
                if (once) observer.disconnect();
              } else if (!once) {
                heading.classList.remove('is-visible');
              }
            });
          },
          { threshold: 0.2 }
        );
        observer.observe(heading);
      });
    }

    function initCarousel(section, carousel) {
      var side = carousel.getAttribute('data-dual-carousel');
      var track = carousel.querySelector('[data-dual-track]');
      var slides = Array.prototype.slice.call(carousel.querySelectorAll('[data-dual-slide]'));
      var prevBtn = carousel.querySelector('[data-dual-prev]');
      var nextBtn = carousel.querySelector('[data-dual-next]');
      var captions = Array.prototype.slice.call(carousel.querySelectorAll('[data-dual-caption]'));
      var viewport = carousel.querySelector('[data-dual-viewport]');

      if (!track || slides.length === 0) return;

      var current = 0;
      var total = slides.length;
      var autoplay = section.getAttribute('data-autoplay-' + side) === 'true';
      var interval = parseInt(section.getAttribute('data-interval-' + side), 10) || 5000;
      var duration = parseInt(section.getAttribute('data-transition-duration'), 10) || 600;
      var autoTimer = null;
      var isDragging = false;
      var startX = 0;
      var deltaX = 0;
      var slideW = 0;
      var slideGap = 0;
      var locked = false;
      var mobileMq = window.matchMedia('(max-width: 749px)');

      track.style.setProperty('--track-duration', duration + 'ms');

      function isMobilePeek() {
        return carousel.classList.contains('oas-dual__carousel--mobile');
      }

      function getSlideStep() {
        if (!isMobilePeek()) {
          return { step: viewport.clientWidth, usePercent: true };
        }
        var slide = slides[0];
        if (!slide) {
          return { step: viewport.clientWidth, usePercent: true };
        }
        var gap = parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0;
        return { step: slide.offsetWidth + gap, usePercent: false };
      }

      function applyTransform(offsetPx) {
        var metrics = getSlideStep();
        slideW = metrics.step;
        slideGap = metrics.usePercent ? 0 : (parseFloat(getComputedStyle(track).columnGap || getComputedStyle(track).gap) || 0);
        if (metrics.usePercent) {
          var basePct = -current * 100;
          if (offsetPx) {
            track.style.transform = 'translateX(calc(' + basePct + '% + ' + offsetPx + 'px))';
          } else {
            track.style.transform = 'translateX(' + basePct + '%)';
          }
        } else {
          var basePx = -current * metrics.step;
          if (offsetPx) {
            track.style.transform = 'translateX(' + (basePx + offsetPx) + 'px)';
          } else {
            track.style.transform = 'translateX(' + basePx + 'px)';
          }
        }
      }

      function updateCaptions() {
        captions.forEach(function (cap, idx) {
          cap.classList.toggle('is-active', idx === current);
        });
      }

      function update() {
        applyTransform(0);
        updateCaptions();
      }

      function goTo(index) {
        if (locked || total < 1) return;
        locked = true;
        current = ((index % total) + total) % total;
        track.classList.remove('is-no-anim');
        applyTransform(0);
        updateCaptions();
        setTimeout(function () { locked = false; }, duration);
      }

      function next() { goTo(current + 1); }
      function prev() { goTo(current - 1); }

      if (prevBtn) prevBtn.addEventListener('click', function () { prev(); resetAutoplay(); });
      if (nextBtn) nextBtn.addEventListener('click', function () { next(); resetAutoplay(); });

      function startAutoplay() {
        if (!autoplay || total < 2) return;
        stopAutoplay();
        autoTimer = setInterval(next, interval);
      }
      function stopAutoplay() {
        if (autoTimer) {
          clearInterval(autoTimer);
          autoTimer = null;
        }
      }
      function resetAutoplay() {
        stopAutoplay();
        startAutoplay();
      }

      viewport.addEventListener('pointerdown', function (e) {
        if (e.button !== 0 && e.pointerType === 'mouse') return;
        if (e.target.closest('[data-dual-play]')) return;
        if (e.target.closest('button')) return;
        isDragging = true;
        startX = e.clientX;
        deltaX = 0;
        slideW = viewport.clientWidth;
        track.classList.add('is-no-anim');
        viewport.classList.add('is-dragging');
        try { viewport.setPointerCapture(e.pointerId); } catch (err) { /* noop */ }
        stopAutoplay();
      });

      viewport.addEventListener('pointermove', function (e) {
        if (!isDragging) return;
        deltaX = e.clientX - startX;
        applyTransform(deltaX);
      });

      function endDrag(e) {
        if (!isDragging) return;
        isDragging = false;
        viewport.classList.remove('is-dragging');
        try { viewport.releasePointerCapture(e.pointerId); } catch (err) { /* noop */ }
        track.classList.remove('is-no-anim');
        var threshold = isMobilePeek()
          ? Math.max(slideW * 0.12, 32)
          : Math.max(slideW * 0.18, 40);
        if (deltaX < -threshold) {
          next();
        } else if (deltaX > threshold) {
          prev();
        } else {
          update();
        }
        deltaX = 0;
        startAutoplay();
      }

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);
      viewport.addEventListener('pointerleave', function (e) {
        if (isDragging) endDrag(e);
      });

      section.addEventListener('mouseenter', stopAutoplay);
      section.addEventListener('mouseleave', startAutoplay);

      function onResize() {
        var metrics = getSlideStep();
        slideW = metrics.step;
        update();
      }

      if (mobileMq.addEventListener) {
        mobileMq.addEventListener('change', onResize);
      } else if (mobileMq.addListener) {
        mobileMq.addListener(onResize);
      }

      window.addEventListener('resize', onResize, { passive: true });

      update();
      requestAnimationFrame(onResize);
      startAutoplay();

      carousel._dualAutoplay = { stop: stopAutoplay, start: startAutoplay };
    }

    function initVideoModal(section) {
      var modal = section.querySelector('[data-dual-modal]');
      var content = section.querySelector('[data-dual-modal-content]');
      var closeEls = section.querySelectorAll('[data-dual-modal-close]');
      var playBtns = section.querySelectorAll('[data-dual-play]');
      if (!modal || !content) return;

      var mobileMq = window.matchMedia('(max-width: 749px)');
      var modalHome = { parent: null, next: null };

      function isMobileModal() {
        return mobileMq.matches;
      }

      function portalModal() {
        if (!isMobileModal() || modal.dataset.dualPortaled === 'true') return;
        modalHome.parent = modal.parentNode;
        modalHome.next = modal.nextSibling;
        document.body.appendChild(modal);
        modal.dataset.dualPortaled = 'true';
      }

      function restoreModal() {
        if (modal.dataset.dualPortaled !== 'true' || !modalHome.parent) return;
        if (modalHome.next && modalHome.next.parentNode === modalHome.parent) {
          modalHome.parent.insertBefore(modal, modalHome.next);
        } else {
          modalHome.parent.appendChild(modal);
        }
        delete modal.dataset.dualPortaled;
        modalHome.parent = null;
        modalHome.next = null;
      }

      function open(html) {
        content.innerHTML = html;
        if (isMobileModal()) {
          portalModal();
          modal.classList.add('is-mobile-full');
        } else {
          modal.classList.remove('is-mobile-full');
        }
        modal.classList.add('is-open');
        modal.setAttribute('aria-hidden', 'false');
        document.body.style.overflow = 'hidden';
        var carousels = section.querySelectorAll('[data-dual-carousel]');
        carousels.forEach(function (c) {
          if (c._dualAutoplay) c._dualAutoplay.stop();
        });
      }

      function close() {
        modal.classList.remove('is-open', 'is-mobile-full');
        modal.setAttribute('aria-hidden', 'true');
        content.innerHTML = '';
        document.body.style.overflow = '';
        restoreModal();
        var carousels = section.querySelectorAll('[data-dual-carousel]');
        carousels.forEach(function (c) {
          if (c._dualAutoplay) c._dualAutoplay.start();
        });
      }

      playBtns.forEach(function (btn) {
        btn.addEventListener('click', function (e) {
          e.preventDefault();
          e.stopPropagation();
          var type = btn.getAttribute('data-video-type');
          var id = btn.getAttribute('data-video-id');
          var src = btn.getAttribute('data-video-src');
          var poster = btn.getAttribute('data-video-poster') || '';
          if (type === 'youtube' && id) {
            open('<iframe src="https://www.youtube.com/embed/' + id + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
          } else if (type === 'vimeo' && id) {
            open('<iframe src="https://player.vimeo.com/video/' + id + '?autoplay=1" allow="autoplay; encrypted-media" allowfullscreen></iframe>');
          } else if (src) {
            open('<video src="' + src + '" controls autoplay playsinline preload="metadata" poster="' + poster + '"></video>');
          }
        });
      });

      closeEls.forEach(function (el) {
        el.addEventListener('click', close);
      });

      document.addEventListener('keydown', function (e) {
        if (e.key === 'Escape' && modal.classList.contains('is-open')) close();
      });
    }

    function shouldInitCarousel(carousel) {
      var mobile = window.matchMedia('(max-width: 749px)').matches;
      var isMobileCarousel = carousel.classList.contains('oas-dual__carousel--mobile');
      return mobile ? isMobileCarousel : !isMobileCarousel;
    }

    function initSection(section) {
      if (!section || !section.matches('.oas-dual')) return;
      initHeadingAnimation(section);
      section.querySelectorAll('[data-dual-carousel]').forEach(function (c) {
        if (shouldInitCarousel(c)) initCarousel(section, c);
      });
      initVideoModal(section);
    }

    function boot() {
      document.querySelectorAll('.oas-dual[data-dual-section]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.oas-dual[data-dual-section]');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-header"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var section = document.currentScript?.closest('.shopify-section') ||
                  document.querySelector('.shopify-section--oas-header');
    if (!section) return;

    function getPinnedAnnouncementHeight() {
      var total = 0;
      document
        .querySelectorAll('.shopify-section--oasmobility-announcement-bar, .shopify-section--announcement-bar')
        .forEach(function (el) {
          if (el.offsetParent === null && el.getBoundingClientRect().height === 0) return;

          var style = window.getComputedStyle(el);
          if (style.display === 'none' || style.visibility === 'hidden') return;
          if (style.position !== 'sticky' && style.position !== 'fixed') return;

          var rect = el.getBoundingClientRect();
          if (rect.bottom <= 0) return;

          // Only count bars currently pinned at top; keep full height to avoid jitter.
          if (rect.top <= 1 && rect.bottom > 1) {
            total += el.offsetHeight;
          }
        });
      return total;
    }

    function syncPanelsTop() {
      var bar = section.querySelector('.oas-header');
      if (!bar) return;
      section.style.setProperty('--oas-panels-top', bar.getBoundingClientRect().bottom + 'px');
    }

    function syncHeaderLayout() {
      var bar = section.querySelector('.oas-header');
      if (!bar) return;

      var annHeight = getPinnedAnnouncementHeight();
      document.documentElement.style.setProperty('--announcement-bar-height', annHeight + 'px');
      section.style.setProperty('--oas-header-sticky-top', annHeight + 'px');

      var headerHeight = bar.offsetHeight;
      document.documentElement.style.setProperty('--header-height', headerHeight + 'px');
      document.documentElement.style.setProperty('--header-is-sticky', '1');
      syncPanelsTop();
    }

    syncHeaderLayout();
    window.addEventListener('resize', syncHeaderLayout);
    window.addEventListener('scroll', syncPanelsTop, { passive: true });
    document.addEventListener('shopify:section:load', syncHeaderLayout);
    document.addEventListener('shopify:section:select', syncHeaderLayout);
    document.addEventListener('shopify:section:reorder', syncHeaderLayout);
    document.addEventListener('shopify:section:unload', syncHeaderLayout);

    if (window.ResizeObserver) {
      var bar = section.querySelector('.oas-header');
      if (bar) new ResizeObserver(syncHeaderLayout).observe(bar);
      document
        .querySelectorAll('.shopify-section--oasmobility-announcement-bar, .shopify-section--announcement-bar')
        .forEach(function (annSection) {
          new ResizeObserver(syncHeaderLayout).observe(annSection);
        });
    }

    var MEGA_CLOSE_DELAY = 250;
    var megaTimers = new Map();

    section.querySelectorAll('[data-mega-trigger]').forEach(function (trigger) {
      var megaPanel = trigger.querySelector('.oas-mega');

      function openMega() {
        clearTimeout(megaTimers.get(trigger));
        section.querySelectorAll('[data-mega-trigger]').forEach(function (other) {
          if (other !== trigger) {
            other.classList.remove('is-open');
            clearTimeout(megaTimers.get(other));
          }
        });
        trigger.classList.add('is-open');
      }

      function schedulClose() {
        megaTimers.set(trigger, setTimeout(function () {
          trigger.classList.remove('is-open');
        }, MEGA_CLOSE_DELAY));
      }

      trigger.addEventListener('mouseenter', openMega);
      trigger.addEventListener('mouseleave', schedulClose);

      if (megaPanel) {
        megaPanel.addEventListener('mouseenter', function () {
          clearTimeout(megaTimers.get(trigger));
          trigger.classList.add('is-open');
        });
        megaPanel.addEventListener('mouseleave', schedulClose);
      }
    });

    var mob = section.querySelector('.oas-mob');
    var openBtn = section.querySelector('[data-oas-open]');

    if (mob && mob.id) {
      // Drop stale portaled copies left under <body> after a re-render.
      document.querySelectorAll('#' + CSS.escape(mob.id)).forEach(function (n) {
        if (n !== mob) n.remove();
      });
    }
    var MOB_INITIAL_CARDS = 4;
    var MOB_MENU_OPEN_CLASS = 'oas-mob-menu-open';

    function lockBodyScroll() {
      document.documentElement.classList.add(MOB_MENU_OPEN_CLASS);
    }

    function unlockBodyScroll() {
      document.documentElement.classList.remove(MOB_MENU_OPEN_CLASS);
    }

    function mobShow() {
      if (!mob) return;
      mob.hidden = false;
      mobGoList();
      mob.scrollTop = 0;
      lockBodyScroll();
      section.classList.add('is-mob-open');
      requestAnimationFrame(function () {
        mob.classList.add('is-open');
      });
      openBtn?.setAttribute('aria-expanded', 'true');
    }

    function mobHide() {
      if (!mob) return;
      mob.classList.remove('is-open');
      unlockBodyScroll();
      section.classList.remove('is-mob-open');
      openBtn?.setAttribute('aria-expanded', 'false');
      mob.hidden = true;
    }

    function mobGoList() {
      mob.querySelectorAll('.oas-mob__view').forEach(function (v) {
        v.classList.toggle('is-active', v.dataset.mobView === 'list');
      });
    }

    function mobGoSub(key) {
      mob.querySelectorAll('.oas-mob__view').forEach(function (v) {
        v.classList.toggle('is-active', v.dataset.mobView === key);
      });
      var panel = mob.querySelector('[data-mob-view="' + key + '"]');
      if (!panel) return;
      var cards = panel.querySelectorAll('[data-mob-card]');
      var btn = panel.querySelector('[data-mob-showmore]');
      cards.forEach(function (c, i) {
        c.hidden = i >= MOB_INITIAL_CARDS;
      });
      if (btn) btn.hidden = cards.length <= MOB_INITIAL_CARDS;
      mob.scrollTop = 0;
    }

    openBtn?.addEventListener('click', function () {
      if (mob && !mob.hidden) { mobHide(); } else { mobShow(); }
    });

    mob?.querySelectorAll('[data-mob-close]').forEach(function (el) {
      el.addEventListener('click', mobHide);
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && mob && !mob.hidden) mobHide();
    });

    window.matchMedia('(min-width: 1000px)').addEventListener('change', function (event) {
      if (event.matches) {
        unlockBodyScroll();
        section.classList.remove('is-mob-open');
        if (mob) {
          mob.classList.remove('is-open');
          mob.hidden = true;
        }
        openBtn?.setAttribute('aria-expanded', 'false');
      }
    });

    mob?.querySelectorAll('[data-mob-open]').forEach(function (el) {
      el.addEventListener('click', function () {
        mobGoSub(el.dataset.mobOpen);
      });
    });

    mob?.querySelectorAll('[data-mob-back]').forEach(function (el) {
      el.addEventListener('click', mobGoList);
    });

    mob?.querySelectorAll('[data-mob-showmore]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var panel = btn.closest('.oas-mob__view');
        if (!panel) return;
        panel.querySelectorAll('[data-mob-card]').forEach(function (c) {
          c.hidden = false;
        });
        btn.hidden = true;
      });
    });

    section.querySelectorAll('[data-sub-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var targetId = btn.getAttribute('aria-controls');
        if (!targetId) return;
        // Use a global lookup: the mobile menu may be portaled to <body>,
        // so it is no longer a descendant of the header section.
        var target = document.getElementById(targetId);
        if (!target) return;
        var willOpen = btn.getAttribute('aria-expanded') !== 'true';
        btn.setAttribute('aria-expanded', willOpen ? 'true' : 'false');
        target.classList.toggle('is-open', willOpen);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-product-craft"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function clamp(n, min, max) {
      return Math.min(Math.max(n, min), max);
    }

    function initTitleAnimation(section) {
      if (section.getAttribute('data-title-animate') !== 'true') return;
      var title = section.querySelector('[data-pd-title]');
      if (!title) return;
      if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        title.classList.add('is-visible');
        return;
      }
      function reveal() {
        title.classList.add('is-visible');
      }
      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                reveal();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.15, rootMargin: '0px 0px -40px 0px' }
        );
        observer.observe(section);
      } else {
        reveal();
      }
    }

    function initMobileCarousel(section) {
      var viewport = section.querySelector('[data-pd-viewport]');
      var track = section.querySelector('[data-pd-track]');
      var progress = section.querySelector('[data-pd-progress]');
      var thumb = section.querySelector('[data-pd-thumb]');
      var prevBtn = section.querySelector('[data-pd-prev]');
      var nextBtn = section.querySelector('[data-pd-next]');
      if (!viewport) return;

      var mobileMq = window.matchMedia('(max-width: 749px)');
      var scrollEdgeThreshold = 4;

      function isMobile() {
        return mobileMq.matches;
      }

      function maxScroll() {
        return Math.max(0, viewport.scrollWidth - viewport.clientWidth);
      }

      function scrollRatio() {
        var max = maxScroll();
        return max <= 0 ? 0 : viewport.scrollLeft / max;
      }

      function thumbTravel() {
        if (!progress || !thumb) return 0;
        return Math.max(0, progress.clientWidth - thumb.offsetWidth);
      }

      function setThumbPosition(ratio) {
        if (!thumb || !isMobile()) return;
        thumb.style.transform = 'translateX(' + ratio * thumbTravel() + 'px)';
        if (progress) {
          progress.setAttribute('aria-valuenow', String(Math.round(ratio * 100)));
        }
      }

      function cardStep() {
        if (!track) return viewport.clientWidth;
        var card = track.querySelector('.oas-proddetail__card');
        if (!card) return viewport.clientWidth;
        var gap = parseFloat(window.getComputedStyle(track).gap) || 0;
        return card.offsetWidth + gap;
      }

      function updateNavButtons() {
        if (!prevBtn && !nextBtn) return;
        if (!isMobile()) {
          if (prevBtn) prevBtn.disabled = false;
          if (nextBtn) nextBtn.disabled = false;
          return;
        }
        var max = maxScroll();
        var left = viewport.scrollLeft;
        if (prevBtn) prevBtn.disabled = left <= scrollEdgeThreshold;
        if (nextBtn) nextBtn.disabled = max <= scrollEdgeThreshold || left >= max - scrollEdgeThreshold;
      }

      function scrollByDirection(dir) {
        if (!isMobile()) return;
        var behavior = window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth';
        viewport.scrollBy({ left: dir * cardStep(), behavior: behavior });
      }

      function onScroll() {
        if (!isMobile()) return;
        setThumbPosition(scrollRatio());
        updateNavButtons();
      }

      var scrollRaf = 0;
      function onScrollRaf() {
        if (scrollRaf) return;
        scrollRaf = requestAnimationFrame(function () {
          scrollRaf = 0;
          onScroll();
        });
      }

      viewport.addEventListener('scroll', onScrollRaf, { passive: true });

      if (progress) {
        progress.addEventListener('click', function (e) {
          if (!isMobile()) return;
          var travel = thumbTravel();
          if (travel <= 0) return;
          var rect = progress.getBoundingClientRect();
          var thumbHalf = thumb ? thumb.offsetWidth / 2 : 0;
          var ratio = clamp((e.clientX - rect.left - thumbHalf) / travel, 0, 1);
          viewport.scrollLeft = ratio * maxScroll();
          setThumbPosition(ratio);
        });
      }

      if (prevBtn) {
        prevBtn.addEventListener('click', function () {
          scrollByDirection(-1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function () {
          scrollByDirection(1);
        });
      }

      mobileMq.addEventListener('change', function () {
        if (isMobile()) {
          setThumbPosition(scrollRatio());
          updateNavButtons();
        } else if (thumb) {
          thumb.style.transform = '';
          updateNavButtons();
        }
      });

      window.addEventListener(
        'resize',
        function () {
          if (isMobile()) {
            setThumbPosition(scrollRatio());
            updateNavButtons();
          }
        },
        { passive: true }
      );

      if (isMobile()) {
        setThumbPosition(0);
        updateNavButtons();
      }

      var drag = null;
      var touch = null;

      function endDrag(e) {
        if (!drag) return;
        viewport.classList.remove('is-dragging');
        try {
          if (e && e.pointerId != null) viewport.releasePointerCapture(e.pointerId);
        } catch (err) { /* noop */ }
        if (drag.moved) {
          var links = viewport.querySelectorAll('.oas-proddetail__card-link');
          links.forEach(function (link) {
            link.addEventListener(
              'click',
              function (ev) {
                ev.preventDefault();
              },
              { once: true, capture: true }
            );
          });
        }
        drag = null;
      }

      viewport.addEventListener('pointerdown', function (e) {
        if (!isMobile()) return;
        if (e.button !== 0 && e.pointerType === 'mouse') return;
        drag = {
          id: e.pointerId,
          x: e.clientX,
          scrollLeft: viewport.scrollLeft,
          moved: false,
        };
        viewport.classList.add('is-dragging');
        viewport.setPointerCapture(e.pointerId);
      });

      viewport.addEventListener(
        'pointermove',
        function (e) {
          if (!drag || drag.id !== e.pointerId) return;
          var dx = e.clientX - drag.x;
          if (Math.abs(dx) > 4) drag.moved = true;
          viewport.scrollLeft = drag.scrollLeft - dx;
        },
        { passive: true }
      );

      viewport.addEventListener('pointerup', endDrag);
      viewport.addEventListener('pointercancel', endDrag);

      viewport.addEventListener(
        'touchstart',
        function (e) {
          if (!isMobile() || e.touches.length !== 1) return;
          touch = {
            x: e.touches[0].clientX,
            y: e.touches[0].clientY,
            scrollLeft: viewport.scrollLeft,
            locked: false,
          };
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchmove',
        function (e) {
          if (!touch || !isMobile()) return;
          var dx = touch.x - e.touches[0].clientX;
          var dy = touch.y - e.touches[0].clientY;
          if (!touch.locked) {
            if (Math.abs(dx) < 6 && Math.abs(dy) < 6) return;
            if (Math.abs(dy) > Math.abs(dx)) {
              touch = null;
              return;
            }
            touch.locked = true;
            viewport.classList.add('is-dragging');
          }
          viewport.scrollLeft = touch.scrollLeft + dx;
          e.preventDefault();
        },
        { passive: false }
      );

      viewport.addEventListener(
        'touchend',
        function () {
          if (touch && touch.locked) {
            var links = viewport.querySelectorAll('.oas-proddetail__card-link');
            links.forEach(function (link) {
              link.addEventListener(
                'click',
                function (ev) {
                  ev.preventDefault();
                },
                { once: true, capture: true }
              );
            });
          }
          touch = null;
          viewport.classList.remove('is-dragging');
        },
        { passive: true }
      );

      viewport.addEventListener(
        'touchcancel',
        function () {
          touch = null;
          viewport.classList.remove('is-dragging');
        },
        { passive: true }
      );
    }

    function initSection(section) {
      initTitleAnimation(section);
      initMobileCarousel(section);
    }

    document.querySelectorAll('[data-pd-section]').forEach(initSection);
    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('[data-pd-section]');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-product-hero"] && !Shopify.designMode) return;
  try {
    
  (function() {
    var section = document.querySelector('.oas-phero');
    if (!section) return;

    var dots = section.querySelectorAll('[data-phero-color]');
    var imgs = section.querySelectorAll('[data-phero-img]');
    var label = section.querySelector('[data-phero-color-label]');

    function applyWatermarkColor(dot) {
      if (!dot) return;
      var wm = dot.getAttribute('data-phero-watermark');
      if (wm) section.style.setProperty('--phero-watermark-color', wm);
    }

    if (dots.length) {
      var initialDot = section.querySelector('[data-phero-color].is-active') || dots[0];
      applyWatermarkColor(initialDot);

      dots.forEach(function(dot) {
        dot.addEventListener('click', function() {
          if (this.classList.contains('is-disabled')) return;
          var targetId = this.getAttribute('data-phero-color');
          var colorName = this.getAttribute('data-phero-label');

          dots.forEach(function(d) { d.classList.remove('is-active'); });
          this.classList.add('is-active');

          imgs.forEach(function(img) {
            img.classList.toggle('is-active', img.getAttribute('data-phero-img') === targetId);
          });

          if (label) label.textContent = colorName;
          applyWatermarkColor(this);
        });
      });
    }

    var specBtn = section.querySelector('[data-phero-spec-trigger]');
    var dialog = section.querySelector('[data-phero-dialog]');
    var closeBtn = section.querySelector('[data-phero-dialog-close]');
    var body = section.querySelector('[data-phero-dialog-body]');
    var fallback = section.querySelector('[data-phero-dialog-fallback]');
    var specSectionId = (section.getAttribute('data-phero-spec-section-id') || '').trim();
    var specPagePath = (section.getAttribute('data-phero-spec-page-path') || '/').trim() || '/';
    var specLoaded = false;
    var specLoading = false;

    function mountRemoteContent(node) {
      if (!node || !body) return false;
      if (fallback) fallback.style.display = 'none';
      var existing = body.querySelector('.oas-phero__dialog-remote');
      if (existing) existing.remove();
      var wrap = document.createElement('div');
      wrap.className = 'oas-phero__dialog-remote oas-phero__dialog-remote--page';
      wrap.appendChild(node);
      body.appendChild(wrap);
      return true;
    }

    function injectRemote(html) {
      if (!html || !body) return false;
      var prose = document.createElement('div');
      prose.className = 'prose';
      prose.innerHTML = html;
      return mountRemoteContent(prose);
    }

    function loadSpecFromTemplate() {
      var tpl = section.querySelector('[data-phero-spec-source]');
      if (!tpl || !tpl.content || !tpl.content.firstElementChild) return false;
      return mountRemoteContent(tpl.content.firstElementChild.cloneNode(true));
    }

    function loadSpecFromPageHtml() {
      if (!specPagePath || specPagePath === '/') return Promise.resolve(false);
      return fetch(specPagePath, { credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.text() : ''; })
        .then(function(html) {
          if (!html) return false;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var mainSection = doc.querySelector('.shopify-section--main-page');
          var prose = mainSection ? mainSection.querySelector('.prose') : null;
          if (!prose) {
            prose = doc.querySelector('main .prose, .prose');
          }
          if (!prose) return false;
          return injectRemote(prose.innerHTML);
        })
        .catch(function() { return false; });
    }

    function loadSpec() {
      if (specLoaded || specLoading || !body) return;
      if (loadSpecFromTemplate()) {
        specLoaded = true;
        return;
      }
      var sectionKey = specSectionId || 'main';
      if (!specPagePath || specPagePath === '/') return;
      specLoading = true;
      var sep = specPagePath.indexOf('?') > -1 ? '&' : '?';
      var url = specPagePath + sep + 'sections=' + encodeURIComponent(sectionKey);
      fetch(url, { credentials: 'same-origin' })
        .then(function(r) { return r.ok ? r.json() : null; })
        .then(function(data) {
          var html = data && (data[sectionKey] || data[Object.keys(data || {})[0]]);
          if (html && injectRemote(html)) {
            specLoaded = true;
            return;
          }
          return loadSpecFromPageHtml();
        })
        .then(function(fallbackOk) {
          if (fallbackOk) specLoaded = true;
        })
        .catch(function() {
          return loadSpecFromPageHtml().then(function(ok) {
            if (ok) specLoaded = true;
          });
        })
        .finally(function() { specLoading = false; });
    }

    if (specBtn && dialog) {
      specBtn.addEventListener('click', function() {
        loadSpec();
        dialog.showModal();
      });

      if (closeBtn) {
        closeBtn.addEventListener('click', function() {
          dialog.close();
        });
      }

      dialog.addEventListener('click', function(e) {
        if (e.target === dialog) {
          dialog.close();
        }
      });
    }
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-scene-carousel"] && !Shopify.designMode) return;
  try {
    
  (function() {
    document.querySelectorAll('.oas-scene').forEach(function(section) {
      var viewport = section.querySelector('[data-scene-viewport]');
      var track = section.querySelector('[data-scene-track]');
      var prevBtn = section.querySelector('[data-scene-prev]');
      var nextBtn = section.querySelector('[data-scene-next]');
      if (!viewport || !track) return;

      var cards = track.querySelectorAll('.oas-scene__card');
      if (!cards.length) return;

      var pos = 0;
      var autoplay = section.getAttribute('data-scene-auto') === 'true';
      var interval = parseInt(section.getAttribute('data-scene-interval'), 10) || 5000;
      var timer = null;
      var scrollTimer = null;
      var isMobile = window.innerWidth < 750;

      function isMobileView() {
        return window.innerWidth < 750;
      }

      function getVisible() {
        if (window.innerWidth < 750) return 1;
        if (window.innerWidth < 1000) return 2;
        return 4;
      }

      function getMaxPos() {
        return Math.max(0, cards.length - getVisible());
      }

      function getStep() {
        var card = cards[0];
        var gap = parseFloat(getComputedStyle(track).gap) || 20;
        return card.offsetWidth + gap;
      }

      function updateNavState() {
        if (prevBtn) prevBtn.disabled = pos <= 0;
        if (nextBtn) nextBtn.disabled = pos >= getMaxPos();
      }

      function scrollToIndex(index, smooth) {
        var step = getStep();
        viewport.scrollTo({
          left: index * step,
          behavior: smooth === false ? 'auto' : 'smooth'
        });
      }

      function update() {
        if (isMobileView()) {
          scrollToIndex(pos, false);
        } else {
          var step = getStep();
          track.style.transform = 'translateX(' + (-pos * step) + 'px)';
        }
        updateNavState();
      }

      function syncPosFromScroll() {
        if (!isMobileView()) return;
        var step = getStep();
        if (step <= 0) return;
        pos = Math.min(Math.max(Math.round(viewport.scrollLeft / step), 0), getMaxPos());
        updateNavState();
      }

      function next() {
        pos = Math.min(pos + 1, getMaxPos());
        if (isMobileView()) {
          scrollToIndex(pos, true);
          updateNavState();
        } else {
          update();
        }
      }

      function prev() {
        pos = Math.max(pos - 1, 0);
        if (isMobileView()) {
          scrollToIndex(pos, true);
          updateNavState();
        } else {
          update();
        }
      }

      if (prevBtn) prevBtn.addEventListener('click', function() { prev(); resetAuto(); });
      if (nextBtn) nextBtn.addEventListener('click', function() { next(); resetAuto(); });

      viewport.addEventListener('scroll', function() {
        if (!isMobileView()) return;
        clearTimeout(scrollTimer);
        scrollTimer = setTimeout(syncPosFromScroll, 80);
      }, { passive: true });

      function startAuto() {
        if (!autoplay || isMobileView()) return;
        timer = setInterval(function() {
          if (pos >= getMaxPos()) { pos = 0; } else { pos++; }
          update();
        }, interval);
      }

      function resetAuto() {
        clearInterval(timer);
        startAuto();
      }

      window.addEventListener('resize', function() {
        var wasMobile = isMobile;
        isMobile = isMobileView();

        if (isMobile) {
          track.style.transform = '';
          pos = Math.min(pos, getMaxPos());
          scrollToIndex(pos, false);
        } else if (wasMobile) {
          viewport.scrollLeft = 0;
          pos = Math.min(pos, getMaxPos());
          update();
        } else {
          pos = Math.min(pos, getMaxPos());
          update();
        }

        updateNavState();
      });

      updateNavState();
      if (!isMobileView()) {
        update();
      }
      startAuto();
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-spec-accordion"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var TRANSITION_MS = 300;

    function openPanel(panel) {
      var body = panel.querySelector('.oas-specacc__body');
      var header = panel.querySelector('.oas-specacc__header');
      if (!body || !header) return;

      panel.classList.add('is-open');
      header.setAttribute('aria-expanded', 'true');
      body.style.maxHeight = body.scrollHeight + 'px';

      var handler = function () {
        if (panel.classList.contains('is-open')) {
          body.style.maxHeight = 'none';
        }
        body.removeEventListener('transitionend', handler);
      };
      body.addEventListener('transitionend', handler);
    }

    function closePanel(panel) {
      var body = panel.querySelector('.oas-specacc__body');
      var header = panel.querySelector('.oas-specacc__header');
      if (!body || !header) return;

      body.style.maxHeight = body.scrollHeight + 'px';
      body.offsetHeight; // force reflow
      body.style.maxHeight = '0px';
      panel.classList.remove('is-open');
      header.setAttribute('aria-expanded', 'false');
    }

    function togglePanel(panel) {
      if (panel.classList.contains('is-open')) {
        closePanel(panel);
      } else {
        openPanel(panel);
      }
    }

    function initSection(container) {
      var panels = container.querySelectorAll('.oas-specacc__panel');

      panels.forEach(function (panel) {
        var header = panel.querySelector('.oas-specacc__header');
        var body = panel.querySelector('.oas-specacc__body');
        if (!header || !body) return;

        if (panel.classList.contains('is-open') && body.style.maxHeight === 'none') {
          body.style.maxHeight = 'none';
        }

        header.addEventListener('click', function () {
          togglePanel(panel);
        });
      });
    }

    function boot() {
      document.querySelectorAll('.oas-specacc').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (e) {
      var section = e.target.querySelector('.oas-specacc');
      if (section) initSection(section);
    });

    document.addEventListener('shopify:block:select', function (e) {
      var panel = e.target.closest('.oas-specacc__panel');
      if (!panel) panel = e.target;
      if (panel && panel.classList.contains('oas-specacc__panel') && !panel.classList.contains('is-open')) {
        openPanel(panel);
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-spec-scene"] && !Shopify.designMode) return;
  try {
    
  (function () {
    function parseCountText(text) {
      if (!text) return null;
      var match = String(text).trim().match(/^([\d,.]+)(.*)$/);
      if (!match) return null;
      var value = parseFloat(match[1].replace(/,/g, ''));
      if (isNaN(value)) return null;
      return { value: value, suffix: match[2] || '', decimals: (match[1].split('.')[1] || '').length };
    }

    function formatCount(value, decimals) {
      if (decimals > 0) return value.toFixed(decimals);
      return String(Math.round(value));
    }

    function easeOutCubic(t) {
      return 1 - Math.pow(1 - t, 3);
    }

    function animateCount(el, target, suffix, decimals, duration) {
      var start = performance.now();
      function tick(now) {
        var progress = Math.min((now - start) / duration, 1);
        var current = target * easeOutCubic(progress);
        el.textContent = formatCount(current, decimals) + suffix;
        if (progress < 1) {
          requestAnimationFrame(tick);
        } else {
          el.textContent = formatCount(target, decimals) + suffix;
        }
      }
      requestAnimationFrame(tick);
    }

    function initSection(section) {
      if (section.getAttribute('data-count-animate') === 'false') return;

      var duration = parseInt(section.getAttribute('data-count-duration'), 10) || 2000;
      var nums = section.querySelectorAll('[data-count-up]');
      if (!nums.length) return;

      var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      nums.forEach(function (el) {
        var parsed = parseCountText(el.getAttribute('data-count-text') || el.textContent);
        if (!parsed) return;
        el.textContent = formatCount(0, parsed.decimals) + parsed.suffix;
        el._countData = parsed;
      });

      if (reducedMotion) {
        nums.forEach(function (el) {
          if (!el._countData) return;
          el.textContent = formatCount(el._countData.value, el._countData.decimals) + el._countData.suffix;
        });
        return;
      }

      var played = false;
      function play() {
        if (played) return;
        played = true;
        nums.forEach(function (el) {
          if (!el._countData) return;
          animateCount(el, el._countData.value, el._countData.suffix, el._countData.decimals, duration);
        });
      }

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(
          function (entries) {
            entries.forEach(function (entry) {
              if (entry.isIntersecting) {
                play();
                observer.disconnect();
              }
            });
          },
          { threshold: 0.35, rootMargin: '0px 0px -10% 0px' }
        );
        observer.observe(section);
      } else {
        play();
      }
    }

    function boot() {
      document.querySelectorAll('.oas-specshow[data-count-animate="true"]').forEach(initSection);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', boot);
    } else {
      boot();
    }

    document.addEventListener('shopify:section:load', function (event) {
      var section = event.target.querySelector('.oas-specshow');
      if (section) initSection(section);
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["oasmobility-video-hero"] && !Shopify.designMode) return;
  try {
    
(function() {
  function parseCountText(text) {
    if (!text) return null;
    var match = String(text).trim().match(/^([\d,.]+)(.*)$/);
    if (!match) return null;
    var value = parseFloat(match[1].replace(/,/g, ''));
    if (isNaN(value)) return null;
    return { value: value, suffix: match[2] || '', decimals: (match[1].split('.')[1] || '').length };
  }

  function formatCount(value, decimals) {
    if (decimals > 0) return value.toFixed(decimals);
    return String(Math.round(value));
  }

  function easeOutCubic(t) {
    return 1 - Math.pow(1 - t, 3);
  }

  function animateCount(el, target, suffix, decimals, duration) {
    var start = performance.now();
    function tick(now) {
      var progress = Math.min((now - start) / duration, 1);
      var current = target * easeOutCubic(progress);
      el.textContent = formatCount(current, decimals) + suffix;
      if (progress < 1) {
        requestAnimationFrame(tick);
      } else {
        el.textContent = formatCount(target, decimals) + suffix;
      }
    }
    requestAnimationFrame(tick);
  }

  function initVheroCountUp(section) {
    if (section.getAttribute('data-vhero-count-animate') !== 'true') return;

    var duration = parseInt(section.getAttribute('data-vhero-count-duration'), 10) || 2000;
    var nums = section.querySelectorAll('[data-count-up]');
    if (!nums.length) return;

    var reducedMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    nums.forEach(function(el) {
      var parsed = parseCountText(el.getAttribute('data-count-text') || el.textContent);
      if (!parsed) return;
      el.textContent = formatCount(0, parsed.decimals) + parsed.suffix;
      el._countData = parsed;
    });

    if (reducedMotion) {
      nums.forEach(function(el) {
        if (!el._countData) return;
        el.textContent = formatCount(el._countData.value, el._countData.decimals) + el._countData.suffix;
      });
      return;
    }

    var played = false;
    function play() {
      if (played) return;
      played = true;
      nums.forEach(function(el) {
        if (!el._countData) return;
        animateCount(el, el._countData.value, el._countData.suffix, el._countData.decimals, duration);
      });
    }

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function(entries) {
          entries.forEach(function(entry) {
            if (entry.isIntersecting) {
              play();
              observer.disconnect();
            }
          });
        },
        { threshold: 0.35, rootMargin: '0px 0px -10% 0px' }
      );
      observer.observe(section);
    } else {
      play();
    }
  }

  function bootVheroCountUp() {
    document.querySelectorAll('[data-vhero-section][data-vhero-count-animate="true"]').forEach(initVheroCountUp);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVheroCountUp);
  } else {
    bootVheroCountUp();
  }

  document.addEventListener('shopify:section:load', function(event) {
    var section = event.target.querySelector('[data-vhero-section]');
    if (section) initVheroCountUp(section);
  });

  document.querySelectorAll('[data-vhero-section]').forEach(function(section) {
    var playBtn = section.querySelector('[data-vhero-play]');
    var modal = section.querySelector('[data-vhero-modal]');
    var player = section.querySelector('[data-vhero-player]');
    var popupTemplate = section.querySelector('[data-vhero-popup-template]');
    var closeBtns = section.querySelectorAll('[data-vhero-modal-close]');

    if (!playBtn || !modal || !player) return;

    function openModal() {
      var videoType = playBtn.getAttribute('data-video-type');
      var videoId = playBtn.getAttribute('data-video-id');
      var embed = '';

      if (videoType === 'youtube' && videoId) {
        embed = '<iframe src="https://www.youtube.com/embed/' + videoId + '?autoplay=1&rel=0" allow="autoplay; encrypted-media" allowfullscreen></iframe>';
      } else if (videoType === 'vimeo' && videoId) {
        embed = '<iframe src="https://player.vimeo.com/video/' + videoId + '?autoplay=1" allow="autoplay" allowfullscreen></iframe>';
      } else if (popupTemplate && popupTemplate.content) {
        player.innerHTML = '';
        player.appendChild(popupTemplate.content.cloneNode(true));
      } else {
        var bgVideo = section.querySelector('.oas-vhero__bg-video');
        if (bgVideo) {
          bgVideo.controls = true;
          bgVideo.muted = false;
          bgVideo.play();
          return;
        }
        return;
      }

      if (embed) player.innerHTML = embed;
      modal.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
    }

    function closeModal() {
      modal.setAttribute('aria-hidden', 'true');
      player.innerHTML = '';
      document.body.style.overflow = '';
    }

    playBtn.addEventListener('click', openModal);
    closeBtns.forEach(function(btn) {
      btn.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && modal.getAttribute('aria-hidden') === 'false') {
        closeModal();
      }
    });
  });
})();

  } catch(e) { console.error(e); }
})();
})();
